import React from "react";

/**
 * MystiCast logo — official brand mark.
 * Transparent PNG with a soft NEON PINK backlight — a diffuse halo that
 * sits behind the logo (not hugging its outline) so it reads as if the
 * shape is lit from behind against the dark UI.
 */
export const MYSTICAST_LOGO_URL = "/mysticast-logo.png";

export function LogoMark({ size = 36, className = "", glow = true }) {
  // Blur & spread scale with size so the halo feels right at any dimension.
  const blur = Math.max(6, Math.round(size * 0.32));
  return (
    <span
      className={`relative inline-block select-none ${className}`}
      style={{ width: size, height: size }}
      data-testid="mysticast-logo-mark"
    >
      {glow && (
        <span
          aria-hidden="true"
          className="absolute pointer-events-none"
          style={{
            inset: "12%",
            background:
              "radial-gradient(circle at 50% 55%, rgba(255,16,83,0.55) 0%, rgba(255,16,83,0.28) 45%, rgba(255,16,83,0) 72%)",
            filter: `blur(${blur}px)`,
            zIndex: 0,
          }}
        />
      )}
      <img
        src={MYSTICAST_LOGO_URL}
        alt="MystiCast logo"
        width={size}
        height={size}
        className="relative block"
        style={{ width: size, height: size, objectFit: "contain", zIndex: 1 }}
        draggable={false}
      />
    </span>
  );
}

/**
 * Full wordmark — logo + "MYSTICAST" + tagline "STREAM. CONNECT. PLAY."
 */
export function LogoWordmark({ tagline = true, size = 36, className = "" }) {
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      <LogoMark size={size} />
      <span className="leading-none">
        <span className="sc-heading font-black tracking-tighter block" style={{ fontSize: `${size * 0.58}px`, lineHeight: 1 }}>
          <span className="text-glow-pink" style={{ color: "var(--sc-pink)" }}>MYSTI</span>
          <span style={{ color: "var(--sc-volt)", textShadow: "0 0 12px var(--sc-volt)" }}>CAST</span>
        </span>
        {tagline && (
          <span className="sc-mono block text-[9px] tracking-[0.28em] mt-1 text-zinc-400">
            <span style={{ color: "var(--sc-volt)" }}>STREAM.</span>{" "}
            <span style={{ color: "var(--sc-pink)" }}>CONNECT.</span>{" "}
            <span style={{ color: "var(--sc-cyan)" }}>PLAY.</span>
          </span>
        )}
      </span>
    </span>
  );
}

export default LogoWordmark;
